import { itemContext } from 'context'
import {
    max,
    min,
    format,
    eachDayOfInterval,
} from 'date-fns'
import _ from 'lodash'
import { 
    EditorState,
    convertToRaw, 
    convertFromRaw,  
} from 'draft-js'
import { momentDate } from 'utils'


class Item {
    constructor(props) {
        let updatedProps = props || {}
        this._id = updatedProps.itemID || updatedProps['_id'];
        this.itemID = updatedProps.itemID || updatedProps['_id'];
        this.sectionID = updatedProps.sectionID;
        this.pageID = updatedProps.pageID;
        this.createdBy = updatedProps.createdBy;
        this.updatedBy = updatedProps.updatedBy;

        this.content = updatedProps.content || '';
        this.priority = updatedProps.priority || itemContext.PRIORITY.NONE.toUpperCase();
        this.status = updatedProps.status || itemContext.STATUS.INCOMPLETE;
        this.tags = updatedProps.tags || [];
        this.notes = updatedProps.notes || JSON.stringify(convertToRaw(EditorState.createEmpty().getCurrentContent()));

        this.parents = updatedProps.parents || [];
        this.children = updatedProps.children || {INCOMPLETE: [], COMPLETED: []};

        this.create_date = updatedProps.create_date || new Date().toString().slice(0,24);
        // this.create_date = updatedProps.create_date || new Date(2021, 11, 1).toString().slice(0,24);
        this.completed_date = updatedProps.completed_date;
        this.start_date = updatedProps.start_date;
        this.end_date = updatedProps.end_date;
        this.start_time = updatedProps.start_time;
        this.end_time = updatedProps.end_time;
        
        this.children_visibility = updatedProps.children_visibility !== undefined ? updatedProps.children_visibility : true;
        this.show_completed = updatedProps.show_completed !== undefined ? updatedProps.show_completed : true;
        this.alerts = updatedProps.alerts || [];

        this.client = updatedProps.client;
        this.clientId = updatedProps.clientId;
        this.clientItemId = updatedProps.clientItemId;
        this.clientTitle = updatedProps.clientTitle;
        this.workflowId = updatedProps.workflowId;

        this.details = {
            sectionID: this.sectionID,
            pageID: this.pageID,
            content: this.content,
            priority: this.priority,
            status: this.status,
            tags: this.tags,
            notes: this.notes,
            parents: this.parents,
            create_date: this.create_date,
            completed_date: this.completed_date,
            start_date: this.start_date,
            end_date: this.end_date,
            start_time: this.start_time,
            end_time: this.end_time,
            children_visibility: this.children_visibility,
            show_completed: this.show_completed,
            alerts: this.alerts,
        }
        this.item = {
            item_details: this.details,
            item_children: this.children
        }

    }

    childHandler = (itemID, item, status_list, data) => {
        let result = {keys: [], nodes: []}
        if(item){
            const item_details = item
            const childrenIDs = item_details['children']
            const show_children = item_details['children_visibility']
            result['keys'].push(itemID)
            result['nodes'].push(item)
            status_list.map((status, index) => {
                if(childrenIDs){
                    if(childrenIDs[status] && show_children){
                        for(const childID of Object.values(childrenIDs[status])) {
                            const child = data['items'][childID]
                            const int_result = this.childHandler(childID, child, status_list, data)
                            result['keys'] = result['keys'].concat(int_result['keys'])
                            result['nodes'] = result['nodes'].concat(int_result['nodes'])
                        }
                    }
                }
            })
        }
        return result
    }

    getFamily(show_completed, data) {
        let items = {keys: [], nodes: []}
        let completedItems = {keys: [], nodes: []}
        const status_list = this.show_completed && show_completed ? [itemContext.STATUS.INCOMPLETE, itemContext.STATUS.COMPLETED] : [itemContext.STATUS.INCOMPLETE]

        if(Object.values(this.children).length > 0){
            // Immediate incompleted items
            if(this.children['INCOMPLETE']){
                Object.values(this.children['INCOMPLETE']).map(itemID => {
                    const result = this.childHandler(itemID, data['items'][itemID], status_list, data)
                    items['keys'] = items['keys'].concat(result['keys'])
                    items['nodes'] = items['nodes'].concat(result['nodes'])
                })
            }

            // Immediate completed items
            if(this.children['COMPLETED'] && this.show_completed && show_completed){
                Object.values(this.children['COMPLETED']).map(itemID => {
                    const result = this.childHandler(itemID, data['items'][itemID], status_list, data)
                    completedItems['keys'] = completedItems['keys'].concat(result['keys'])
                    completedItems['nodes'] = completedItems['nodes'].concat(result['nodes'])
                })
            }
        }

        // let result = items
        // result['keys'].concat(completedItems['keys'])
        // result['nodes'].concat(completedItems['nodes'])
        // result = result['keys'].length > 0 ? Object.assign(...items['keys'].map((k, i) => ({[k]: items['nodes'][i]}))) : null;
        // return {all: result, incomplete: items, completed: completedItems}

        let result = items
        result['keys'] = result['keys'].concat(completedItems['keys'])
        result['nodes'] = result['nodes'].concat(completedItems['nodes'])
        result = result['keys'].length > 0 ? Object.assign(...items['keys'].map((k, i) => ({[k]: items['nodes'][i]}))) : {};
        return result
    }

    familyCount(show_completed, data) {
        let values = {
            total: 0,
            incomplete: 0,
            completed: 0
        }
        // if(!this.children_visibility){
        //     return values
        // }
        const incomplete = Object.values(data['items']).filter(item => item['parents'].includes(this.itemID) & item['status'] === itemContext.STATUS.INCOMPLETE)
        const completed = Object.values(data['items']).filter(item => item['parents'].includes(this.itemID) & item['status'] === itemContext.STATUS.COMPLETED)
        values['incomplete'] = incomplete.length 
        values['completed'] = completed.length 
        values['total'] = values['incomplete'] + values['completed']
        return values
    }

    getPlainText(){
        const blocks = JSON.parse(this.content)['blocks']
        let value
        if(blocks && blocks.length > 0){
            value = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
            value = value.toString().trim()
        }
        return value
    }

    getAlert(timezone){
        const alertDate = this.start_time ? momentDate(this.start_time, timezone) :
                        this.end_time ? momentDate(this.end_time, timezone) :
                        this.start_date ? momentDate(this.start_date, timezone) :
                        this.end_date ? momentDate(this.end_date, timezone) :
                        null
        const alertType = this.start_time || this.end_time ? 'time' : 'day'
        return {date: alertDate, type: alertType}
    }

    getAllAlerts(){
        // Get full tree
        const family = this.getFamily(true)
        let tree = {}
        tree[this.itemID] = this.item
        tree = _.merge(tree, family['all'])

        // Traverse through tree
        let alerts = {}
        Object.values(tree).map(item => {
            alerts = item['item_details']['alerts'] ? _.merge(alerts, item['item_details']['alerts']) : alerts
        })

        return alerts
    }

    getScheduleRange() {
        let dates = _.compact(_.uniq([
            this.start_date && new Date(this.start_date),
            this.end_date && new Date(this.end_date),
            this.start_time && new Date(this.start_time),
            this.end_time && new Date(this.end_time),
        ]))
        if(dates.length > 0){
            const maxDate = new Date(max(dates)).setHours(0,0,0,0)
            const minDate = new Date(min(dates)).setHours(0,0,0,0)
            if(maxDate > minDate){
                dates = eachDayOfInterval({
                    start: minDate,
                    end: maxDate
                })
            }
        }
        dates = _.compact(_.uniq(dates.map(d => d && (format(d, 'LLL d Y')))))
        return dates
    }

    hasSchedule() {
        if(this.start_date || this.end_date || this.start_time || this.end_time){
            return true
        } else {
            return false
        }
    }
}



export default Item;


